module.exports = __webpack_public_path__ + "img/img12.c4769dba.svg";